export class BuyerDataError extends Error {}
